import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListModule } from 'src/@fury/shared/list/list.module';
import { FurySharedModule } from 'src/@fury/fury-shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatOptionModule } from '@angular/material/core';

import { PostLeadRequestRoutingModule } from './post-lead-request-routing.module';
import { PostLeadRequestComponent } from './post-lead-request.component';
import { PostEmailUsageZoneComponent } from './post-email-usage-zone/post-email-usage-zone.component';
import { PostIpUsageZoneComponent } from './post-ip-usage-zone/post-ip-usage-zone.component';
import { PostPhoneUsageZoneComponent } from './post-phone-usage-zone/post-phone-usage-zone.component';
import { PostLeadRequestListComponent } from './post-lead-request-list/post-lead-request-list.component';


@NgModule({
  declarations: [
    PostLeadRequestComponent,
    PostEmailUsageZoneComponent,
    PostIpUsageZoneComponent,
    PostPhoneUsageZoneComponent,
    PostLeadRequestListComponent
  ],
  imports: [
    CommonModule,
    PostLeadRequestRoutingModule,
    ListModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    MatSelectModule,
    MatChipsModule,
    MatPaginatorModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    FlexLayoutModule,
    MatSlideToggleModule,
    NgxPaginationModule,
    MatCheckboxModule,
    MatIconModule,
    MatOptionModule,
    FurySharedModule
  ]
})
export class PostLeadRequestModule { }
